import script from "./officeMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./officeMain.vue?vue&type=script&lang=ts&setup=true"

import "./officeMain.vue?vue&type=style&index=0&id=76c03fdd&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c03fdd"]])

export default __exports__